<template>
  <md-field class="field">
    <label class="label" :style="`background-color:${labelBg}`">{{label}}</label>
    <md-input
      class="input"
      :name="name"
      :id="id"
      :type="type"
      :required="required"
      v-model="content"
      @input="handleInput"
    ></md-input>
  </md-field>
</template>

<script>
export default {
  name: 'NormalInput',
  props: {
    name: String,
    value: String,
    id: String,
    label: String,
    type: {
      type: String,
      default: 'text',
    },
    required: String,
    labelBg: {
      type: String,
      default: '#330e2f',
    },
  },
  data() {
    return {
      content: this.value,
    };
  },
  methods: {
    handleInput() {
      this.$emit('input', this.content);
    },
  },
};
</script>

<style lang="scss">
.md-field.field .md-button {
  top: 26px !important;
  right: 10px !important;
}
</style>

<style scoped lang="scss">
.md-field.field {
  margin: 4px 0 3px;

  &:before {
    display: none;
  }

  &:after {
    display: none;
  }

  &.md-focused,
  &.md-has-value {
    label.label {
      top: 6px;
      left: 10px;
    }

    .md-input.input {
      color: #979797;
      -webkit-text-fill-color: unset;
    }
  }

  &.md-focused {
    .md-input.input {
      border: 1px solid #ff5f3c;
      transition: 0.3s ease all;
      color: #ff5f3c;
      -webkit-text-fill-color: unset;
    }

    label.label {
      color: #ff5f3c;
    }
  }

  .md-input.input {
    border: 1px solid #d8d8d8;
    border-radius: 5px;
    height: 54px;
    font-size: 16px;
    color: #979797;
    -webkit-text-fill-color: unset;
    transition: 0.3s ease all;
    padding: 0 15px;
  }

  label.label {
    font-family: "Montserrat", sans-serif;
    font-size: 16px;
    color: #979797;
    top: 33px;
    left: 20px;
    padding-left: 5px;
    padding-right: 5px;
  }
}
</style>
